import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { AsyncDateTimeFieldEditView } from '@atlassian/jira-issue-field-date-time/src/ui/edit/async.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { FieldLoader } from '../../common/ui/field-loader/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { preventFormSubmitOnEnterKeyPress } from '../../common/utils/date/index.tsx';
import { validateString } from '../../common/utils/validators/index.tsx';
import messages from './messages.tsx';
import type { Props, DateTimeFieldConfig, FieldValue } from './types.tsx';

export const DateTimeField = (props: Props): React.JSX.Element => {
	const {
		autoFocus = false,
		width,
		fieldProps: { value, onChange, isDisabled, ...fieldProps },
		error,
		isReadOnly = false,
		fieldName,
	} = props;
	const { formatMessage } = useIntl();

	const handleChange = (dateTimeValue: string | null) => {
		onChange(dateTimeValue || '');
	};

	return (
		<FieldContainer width={width}>
			<Placeholder name="date-time-field-edit-view" fallback={<FieldLoader />}>
				<AsyncDateTimeFieldEditView
					label={fieldName}
					{...fieldProps}
					isDisabled={isDisabled || isReadOnly}
					autoFocus={autoFocus}
					value={value}
					onChange={handleChange}
					isInvalid={Boolean(error)}
					datePickerProps={{
						selectProps: {
							onKeyDown: preventFormSubmitOnEnterKeyPress,
						},
						placeholder: formatMessage(messages.datePickerPlaceholder),
					}}
					timePickerProps={{
						placeholder: formatMessage(messages.timePickerPlaceholder),
					}}
				/>
			</Placeholder>
		</FieldContainer>
	);
};

export default withFormField({ validator: validateString })<DateTimeFieldConfig, FieldValue>(
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
	DateTimeField,
);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutateDateTimeField } from './utils';
